import { EquipmentType } from './../../../common/equipment.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormularDetailLayoutItemProvider, DetailLayout } from '@sdbn/common';

@Component({
    selector: 'app-equipment-admin-attributes',
    templateUrl: './equipment-admin-attributes.component.html',
    styleUrls: ['./equipment-admin-attributes.component.scss'],
    standalone: false
})
export class EquipmentAdminAttributesComponent {

  data = {};

  layout = new DetailLayout();

  itemProvider = new FormularDetailLayoutItemProvider();

  equipmentType: EquipmentType;

  @Input('equipmentType') set setEquipmentType(value: EquipmentType) {
    this.equipmentType = value;
    if (this.equipmentType?.attributeDefinition != null) {
      this.layout = new DetailLayout(JSON.parse(this.equipmentType?.attributeDefinition));
    } else {
      this.layout = new DetailLayout();
    }
  }

  @Output() changed = new EventEmitter<DetailLayout>();

  public onChange() {
    this.layout = new DetailLayout(this.layout);
    this.changed.emit(this.layout);
  }

}
